<template>
    <BuilderBase cssClassContent="content-type-32">
        <template v-slot:section-full>
            <div class="col-12">
                <div class="full-page">
                    <div class="content">
                        <div class="h6">{{ $t('views.dataset_consult_requested.title_short')}}</div>
                        <h1 class="h1" v-html="$t('views.dataset_consult_requested.title')"></h1>
                        <p class="p">{{ $t('views.dataset_consult_requested.description')}}</p>
                        <div class="buttons">
                            <router-link :to="{ name: 'builder' }" class="btn-1 btn-m-icon">
                                <span>{{ $t('views.dataset_consult_requested.back')}}</span>
                                <div class="icon-arrow-pos"></div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </BuilderBase>
</template>

<script>
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import BuilderBase from '@/views/builder/BuilderBase';
    import { scrollToTop } from '@/utils/scroll';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            BuilderBase
        },
        data() {
            return {
                seo_title: 'views.dataset_consult_requested.seo_title'
            };
        },
        mounted() {
            scrollToTop();
        }
    }
</script>